var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"goldTxRecord_body"},[_c('headerTitle',{attrs:{"titleName":'提现设置'}}),_c('tradingCurrencyConfig',{attrs:{"tradingCurrencyList":_vm.tradingCurrencyList},on:{"getList":_vm.getList}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }